'use client'

import VaultRolesLoading from './VaultRolesLoading'

/** Mirrors `VaultRolesLayout`, title included. */
const VaultRolesSectionLoading = () => {
  return (
    <div className="gap-sm flex flex-col">
      <span className="text-foreground text-sm">Vault Roles</span>
      <VaultRolesLoading />
    </div>
  )
}

export default VaultRolesSectionLoading
